export default __webpack_public_path__ + "media/images/react_icons/casatb/phone_gray-79291db05df63ca3003588f141d0f0aa.svg";